<template>
  <c-step
    stepperGrpCd="LICENSE_REQUEST_STEP_CD"
    :currentStepCd="currentStepCd"
    :param="param"
    v-model="stepCd"
    @currentStep="currentStep"
    @closePopup="closePopup"
    @stepClick="stepClick"
   >
  </c-step>
</template>

<script>
export default {
  name: 'license-request-step',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        stepCd: '',
        limLicenseRequestId: '',
        count: 0,
      }),
    },
  },
  data() {
    return {
      editable: true,
      stepCd: '',
      currentStepCd: '',
    };
  },
  watch: {
  },
  computed: {
    param() {
      return {
        limLicenseRequestId: this.popupParam.limLicenseRequestId,
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.setStep();
    },
    setStep() {
      if (!this.popupParam.stepCd || this.popupParam.stepCd === 'RSC0000001' || this.popupParam.stepCd === 'RSC0999999') {
        this.stepCd = 'LRSC000001'
        this.currentStepCd = 'LRSC000001'
      } else {
        this.stepCd = 'LRSC000002'
        this.currentStepCd = 'LRSC000002'
      }
    },
    currentStep(step) {
      if (!step || step === 'RSC0000001' || this.popupParam.stepCd === 'RSC0999999') {
        this.stepCd = 'LRSC000001'
        this.currentStepCd = 'LRSC000001'
      } else {
        this.stepCd = 'LRSC000002'
        this.currentStepCd = 'LRSC000002'
      }
      this.popupParam.stepCd = step;
    },
    closePopup() {
      this.$emit('closePopup')
    },
    stepClick() {
      this.popupParam.count++;
    },
  }
};
</script>
